import React, { useEffect, useState } from "react";
import { Card, Row, Col, Form, Tab, Tabs} from "react-bootstrap";
import moment from "moment";
import { useTranslation } from 'react-i18next';

const Overview = ({ todayProgress, todayEmployees = [], relationData, onInventoryClick, onViewAllHistory, todayTasks,
  weekTasks, onViewAllTasks }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (todayEmployees) {
      setIsLoading(false);
    }
    console.log("todayEmployees", todayEmployees)
  }, [todayEmployees]);

  const getTaskDate = (task) => {
    return moment(task.WeekStartDate)
      .isoWeekday(
        ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"]
          .indexOf(task.DayOfWeek.toLowerCase()) + 1
      );
  };

  const renderStatusBadge = (status, t) => {
    let normalizedStatus = "";

    if (!isNaN(status) && status !== null && status !== "") {
      switch (Number(status)) {
        case 0: normalizedStatus = "planned"; break;
        case 1: normalizedStatus = "inprogress"; break;
        case 2: normalizedStatus = "completed"; break;
        case 3: normalizedStatus = "unabletoaccess"; break;
        case 4: normalizedStatus = "notavailable"; break;
        case 5: normalizedStatus = "equipmentissue"; break;
        case 6: normalizedStatus = "cancelled"; break;
        case 7: normalizedStatus = "incomplete"; break;
        default: normalizedStatus = "planned"; break;
      }
    } else {
      normalizedStatus = (status || "")
        .toString()
        .replace(/\s+/g, "")
        .toLowerCase();
    }

    //  Bootstrap variants
    const variantMap = {
      planned: "primary",
      inprogress: "info",
      completed: "success",
      cancelled: "danger",
      unabletoaccess: "warning",
      notavailable: "warning",
      equipmentissue: "warning",
      incomplete: "warning",
    };

    const variant = variantMap[normalizedStatus] || "secondary";
    return (
      <span className={`badge badge-subtle fw-medium bg-${variant} px-2 py-1 font-size-12`}>
        {t?.(`orderDetailStatus.${normalizedStatus}`) || normalizedStatus}
      </span>
    );
  };

  const today = moment().startOf("day");

  const sortedWeekTasks = [...weekTasks].sort((a, b) => {
    // sorted jobs like todays at top, upcoming in middle and passed at last
    const dateA = getTaskDate(a).startOf("day");
    const dateB = getTaskDate(b).startOf("day");

    const aIsPast = dateA.isBefore(today);
    const bIsPast = dateB.isBefore(today);

    //  Push past dates to bottom 
    if (aIsPast && !bIsPast) return 1;
    if (!aIsPast && bIsPast) return -1;

    //  Otherwise sort by date ascending
    return dateA.diff(dateB);
  });

  const avatarColors = [
    { bg: "bg-danger-subtle", text: "text-danger" },
    { bg: "bg-warning-subtle", text: "text-warning" },
    { bg: "bg-primary-subtle", text: "text-primary" },
    { bg: "bg-info-subtle", text: "text-info" },
    { bg: "bg-success-subtle", text: "text-success" }
  ];

  const TaskCard = ({ task, showDate }) => {
    const dateLabel = getTaskDate(task).format("DD MMM");

    // Normalize status (same logic as your badge)
    let normalizedStatus = "";

    if (!isNaN(task.Status) && task.Status !== null && task.Status !== "") {
      switch (Number(task.Status)) {
        case 0: normalizedStatus = "planned"; break;
        case 1: normalizedStatus = "inprogress"; break;
        case 2: normalizedStatus = "jobcomplete"; break;
        case 3: normalizedStatus = "unabletoaccesslocation"; break;
        case 4: normalizedStatus = "customernotavailable"; break;
        case 5: normalizedStatus = "equipmentissue"; break;
        case 6: normalizedStatus = "cancelledbycustomer"; break;
        case 7: normalizedStatus = "incomplete"; break;
        default: normalizedStatus = ""; break;
      }
    } else {
      normalizedStatus = (task.Status || "")
        .toString()
        .replace(/\s+/g, "")
        .toLowerCase();
    }

    return (
      <div className={`task-card ${normalizedStatus} p-3 rounded-3 shadow-none card-hover`}>
        <div className="d-flex justify-content-between align-items-start">

          {/* LEFT */}
          <div>
            <p className="mb-1 text-muted fw-medium font-size-13">
              {task.TaskName}
            </p>
            <p className="text-muted d-flex align-items-center gap-1 mb-0 fw-normal font-size-12">
              <i className="fas fa-map-marker-alt"></i>
              {relationData?.StreetName || "Street 22"}, {relationData?.PostCode || "4567GH"}, {relationData?.City || "Amsterdam"}
            </p>
          </div>

          {/* RIGHT - Status badge with date below centered */}
          <div className="d-flex flex-column align-items-center gap-1">
            <span>
              {renderStatusBadge(task.Status, t)}
            </span>
            {showDate && (
              <span className="text-muted small align-self-end text-end fw-normal font-size-12">
                {dateLabel}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Row className="g-3 align-items-start">
      {/* Left Column - Current Progress + Tasks */}
      <Col lg={6} md={12} className="d-flex flex-column">
        {/* Current Progress */}
        <Card className="mb-3 flex-grow-0 shadow-none card-hover border">
          <Card.Body>
            <div className="d-flex align-items-start">
              <i className="fas fa-chart-line text-secondary me-2 mt-1"></i>
              <div>
                <h3 className="mb-0 fw-medium font-size-15">{t("currentProgress")}</h3>
                <p className="text-muted d-block fw-normal font-size-13">{t("liveOrderStatuss")}</p>
              </div>
            </div>

            <Row className="g-3">
              <Col sm={6} lg={3}>
                <div className="rounded-4 p-3 h-100 card-hover shadow-none cursor-pointer card-success-soft">
                  <span className="d-block text-success-bright fw-bolder font-size-22">
                    {todayProgress.workOnSite}
                  </span>

                  <span className="d-block text-success-bright fw-medium font-size-12">
                    {t("workerOnSite")}
                  </span>

                  <span className="d-block text-success-bright fw-normal font-size-11">
                    <span className="me-1">●</span> {t("live")}
                  </span>
                </div>
              </Col>

              <Col sm={6} lg={3}>
                <div className="rounded-4 p-3 h-100 card-hover shadow-none cursor-pointer card-warning-soft">
                  <span className="d-block text-warning-bright fw-bolder font-size-22">
                    {todayProgress.tasksActive}
                  </span>

                  <span className="d-block text-warning-bright fw-medium font-size-12">
                    {t("tasksActive")}
                  </span>

                  <span className="d-block text-warning-bright fw-normal font-size-11">
                    {t("inProgress")}
                  </span>
                </div>
              </Col>

              <Col sm={6} lg={3}>
                <div className="rounded-4 p-3 h-100 card-hover shadow-none cursor-pointer card-info-soft">
                  <span className="d-block text-info-bright fw-bolder font-size-22">
                    {todayProgress.tasksDone}
                  </span>

                  <span className="d-block text-info-bright fw-medium font-size-12">
                    {t("tasksDone")}
                  </span>

                  <span className="d-block text-info-bright fw-normal font-size-11">
                    {t("completed")}
                  </span>
                </div>
              </Col>

              <Col sm={6} lg={3}>
                <div className="rounded-4 p-3 h-100 card-hover shadow-none cursor-pointer card-teal-soft">
                  <span className="d-block text-teal-bright fw-bolder font-size-22">
                    0
                  </span>

                  <span className="d-block text-teal-bright fw-medium font-size-12">
                    {t("inspections")}
                  </span>

                  <span className="d-block text-teal-bright fw-normal font-size-11">
                    {t("verified")}
                  </span>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Tasks */}
        <Card className="flex-grow-1 shadow-none card-hover border">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-start">
              <div className="d-flex align-items-start">
                <i className="fas fa-tasks text-secondary me-2 mt-1"></i>
                <div>
                  <h3 className="mb-0 fw-medium font-size-15">{t("tasks")}</h3>
                  <p className="text-muted d-block fw-normal font-size-13">{t("operationalOverview")}</p>
                </div>
              </div>

              <div className="d-flex">
                <Form.Select size="sm" className="fs-11">
                  <option>{t("floorCleaner")}</option>
                  <option value="window">{t("windowCleaner")}</option>
                  <option value="floor">{t("washWalls")}</option>
                </Form.Select>
              </div>
            </div>

            <Row className="g-3 mb-0 justify-content-center align-items-stretch">
              <Col lg={12} xxl={12}>
                <Card className="h-70 shadow-none">
                  <Card.Body className="p-0">
                    <Tabs
                      defaultActiveKey="ongoing"
                      id="tasks-overview-tabs"
                      transition={false}
                    >
                      <Tab
                        eventKey="ongoing"
                        title={t("ongoing")}
                        className="border-bottom border-x p-3"
                      >
                        <div className="d-flex flex-column gap-3 scrollbar pe-1 pt-2 tab-scroll-container">
                          {todayTasks.length === 0 ? (
                            <div className="text-muted small fs-11 text-center mt-5">
                              {t("noTasksToday")}
                            </div>
                          ) : (
                            todayTasks.map(task => (
                              <TaskCard
                                key={task.OrderDetailId}
                                task={task}
                                showDate={false}
                              />
                            ))
                          )}
                        </div>
                      </Tab>

                      <Tab
                        eventKey="thisWeek"
                        title={t("thisWeek")}
                        className="border-bottom border-x p-3"
                      >
                        <div className="d-flex flex-column gap-3 scrollbar pe-1 pt-2 tab-scroll-container">
                          {sortedWeekTasks.length === 0 ? (
                            <div className="text-muted small fs-11 text-center mt-5">
                              {t("noTasksThisWeek")}
                            </div>
                          ) : (
                            sortedWeekTasks.map(task => (
                              <TaskCard
                                key={task.OrderDetailId}
                                task={task}
                                showDate={true}
                              />
                            ))
                          )}
                        </div>
                      </Tab>
                    </Tabs>
                    <div className="text-center mt-auto">
                      <button
                        type="button"
                        onClick={onViewAllTasks}
                        className="btn p-0 d-inline-block px-3 py-2 rounded view-inventory-link  shadow-none text-decoration-none mt-1 fw-medium font-size-12">
                        {t("viewAllTasks")}
                      </button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>

      {/* Right Column - Inventory & Live Activity + On Site */}
      <Col lg={6} md={12} className="d-flex flex-column">
        {/* Top Right - Inventory & Live Activity */}
        <Row className="g-3 mb-3 flex-grow-0">
          {/* Inventory */}
          <Col md={6}>
            <Card className="shadow-none card-hover border" style={{ height: "377px" }}>
              <Card.Body className="d-flex flex-column">
                <div className="d-flex align-items-start">
                  <i className="fas fa-dolly-flatbed text-secondary me-2 mt-1"></i>
                  <div>
                    <h3 className="mb-0 fw-medium font-size-15">{t("inventory")}</h3>
                    <p className="text-muted d-block fw-normal font-size-13">{t("materialStatus")}</p>
                  </div>
                </div>
                {/* <div className="alert alert-warning py-1 px-3 mb-3 app-warning-alert">
                  <i className="fas fa-exclamation-triangle me-2 app-warning-icon"></i>
                  <span className="app-warning-text fw-medium font-size-12">
                    {t("attentionNeeded")}
                  </span>
                </div>
                <div className="flex-grow-1 d-flex flex-column mb-0">
                  <div className="flex-grow-1 d-flex flex-column">
                    <div className="row text-center mb-1">
                      <div className="col-4">
                        <span className="display-6 text-success fw-bolder font-size-22">15</span>
                        <span className="d-block inventory-count-label fw-normal font-size-12">
                          {t("inStock")}
                        </span>
                      </div>

                      <div className="col-4">
                        <span className="display-6 text-warning fw-bolder font-size-22">10</span>
                        <span className="d-block inventory-count-label fw-normal font-size-12">
                          {t("low")}
                        </span>
                      </div>

                      <div className="col-4">
                        <div className="display-6 text-danger pb-1 fw-bolder font-size-22">1</div>
                        <span
                          className={ `d-block inventory-count-label fw-normal font-size-12 ${
                            localStorage.getItem('culture') === 'en' ? 'text-nowrap' : ''
                          }` } 
                        >
                          {t("outOfStock")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <hr className="mb-3 mt-0" />

                  <div className="mb-2 d-flex justify-content-between align-items-center">
                    <p className="text-muted mb-0 fw-medium font-size-13">{t("glassCleanerSolution")}</p>
                    <span className="badge rounded-3 px-2 py-1 inventory-qty-success fw-normal font-size-12">
                      5 {t("units")}
                    </span>
                  </div>

                  <div className="mb-2 d-flex justify-content-between align-items-center">
                    <p className="text-muted mb-0 fw-medium font-size-13">{t("microfiberCloths")}</p>
                    <span className="badge rounded-3 px-2 py-1 inventory-qty-success fw-normal font-size-12">
                      8 {t("units")}
                    </span>
                  </div>

                  <div className="mb-2 d-flex justify-content-between align-items-center">
                    <p className="text-muted mb-0 fw-medium font-size-13">{t("floorPolish")}</p>
                    <span className="badge rounded-3 px-2 py-1 inventory-qty-danger fw-normal font-size-12">
                      {t("out")}
                    </span>
                  </div>

                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <p className="text-muted mb-0 fw-medium font-size-13">{t("acidBottles")}</p>
                    <span className="badge rounded-3 px-2 py-1 inventory-qty-warning fw-normal font-size-12">
                      2 {t("left")}
                    </span>
                  </div>
                </div> */}

                <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                  <div className="text-center">
                    {t("NoDataFound")}
                  </div>
                </div>

                <div className="text-center mt-auto">
                  <button
                    type="button"
                    // onClick={onInventoryClick}
                    className="btn p-0 d-inline-block px-3 py-2 rounded view-inventory-link shadow-none text-decoration-none fw-medium font-size-12"
                  >
                    {t("viewFullInventory")}
                  </button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Live Activity */}
          <Col md={6}>
            <Card className=" shadow-none card-hover border" style={{ height: "377px" }}>
              <Card.Body className="d-flex flex-column h-100 -end">
                <div className="d-flex align-items-start">
                  <i className="fas fa-sliders-h text-secondary me-2 mt-1"></i>
                  <div>
                    <h3 className="mb-0 fw-medium font-size-15">{t("liveActivity")}</h3>
                    <p className="text-muted d-block fw-normal font-size-12">{t("recentUpdates")}</p>
                  </div>
                </div>

                {/* <div className="flex-grow-1 overflow-auto">
                  <div className="position-relative ps-3">
                    <div className="position-relative pb-3">
                      <div className="position-absolute start-0 top-0 translate-middle-x">
                        <div className="rounded-circle activity-dot bg-success"></div>
                      </div>
                      <div className="position-absolute start-0 top-0 translate-middle-x border-start border-2 activity-line"></div>
                      <div className="ps-3">
                        <p className="mb-0 text-muted fw-medium font-size-13">
                          {t("lobbyFloorPolishingCompleted")}
                        </p>
                        <span className="text-muted d-block mt-0 fw-normal font-size-12">
                          Willem • 1 hr ago
                        </span>
                      </div>
                    </div>

                    <div className="position-relative pb-3">
                      <div className="position-absolute start-0 top-0 translate-middle-x">
                        <div className="rounded-circle activity-dot bg-warning"></div>
                      </div>
                      <div className="position-absolute start-0 top-0 translate-middle-x border-start border-2 activity-line"></div>
                      <div className="ps-3">
                        <p className="mb-0 text-muted fw-medium font-size-13">
                          {t("windowCleaning2ndFloorStarted")}
                        </p>
                        <span className="text-muted d-block mt-0 d-block mt-0 fw-normal font-size-12">
                          Will jacks • 1 hr ago
                        </span>
                      </div>
                    </div>

                    <div className="position-relative pb-3">
                      <div className="position-absolute start-0 top-0 translate-middle-x">
                        <div className="rounded-circle activity-dot bg-info"></div>
                      </div>
                      <div className="position-absolute start-0 top-0 translate-middle-x border-start border-2 activity-line"></div>
                      <div className="ps-3">
                        <p className="mb-0 text-muted fw-medium font-size-13">
                          {t("initialInspectionReportUploaded")}
                        </p>
                        <span className="text-muted d-block mt-0 fw-normal font-size-12">
                          James Wilson • 1 hr ago
                        </span>
                      </div>
                    </div>

                    <div className="position-relative">
                      <div className="position-absolute start-0 top-0 translate-middle-x">
                        <div className="rounded-circle activity-dot bg-primary"></div>
                      </div>
                      <div className="ps-3">
                        <p className="mb-0 text-muted fw-medium font-size-13">
                          {t("conferenceRoomWallCleaningCompleted")}
                        </p>
                        <span className="text-muted d-block mt-0 fw-normal font-size-12">
                          Nick Smits • 5 hrs ago
                        </span>
                      </div>
                    </div>
                  </div>
                </div> */}

                <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                  <div className="text-center">
                    {t("NoDataFound")}
                  </div>
                </div>

                <div className="text-center mt-auto">
                  <button
                    type="button"
                    className="btn p-0 d-inline-block px-3 py-2 rounded view-inventory-link shadow-none text-decoration-none fw-medium font-size-12"
                  >
                    {t("viewAllHistory")}
                  </button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Bottom Right - On Site */}
        <Row className="g-3 flex-grow-1">
          <Col md={6}>
            <Card
              className={`pb-4 shadow-none card-hover border d-flex flex-column ${localStorage.getItem("culture") === "nl"
                  ? "onsite-card-height-nl"
                  : "onsite-card-height"
                }`}
            >
              <Card.Body className="fs-10 d-flex flex-column onsite-card-body">
                <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-user-friends text-secondary me-2 mt-1"></i>
                    <div>
                      <h3 className="mb-0 fw-medium font-size-15">{t("onSite")}</h3>
                      <small className="text-muted d-block text-sm-nowrap fw-normal font-size-13">
                        {todayEmployees.filter(emp => emp.status === "online").length} {t("active")} •{" "}
                        {todayEmployees.filter(emp => emp.status === "offline").length} {t("scheduled")}
                      </small>
                    </div>
                  </div>

                  <div className="d-flex ms-auto ms-sm-0">
                    <Form.Select size="sm" className="fs-11 w-auto">
                      <option>{t("floorCleaner")}</option>
                      <option value="floor">{t("washwalls")}</option>
                    </Form.Select>
                  </div>
                </div>

                <div className="overflow-y-auto overflow-hidden scrollbar flex-grow-1">
                  {isLoading ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <div className="spinner-border text-secondary app-spinner-sm" role="status">
                        <span className="visually-hidden">{t("loading")}</span>
                      </div>
                    </div>
                  ) : todayEmployees.length === 0 ? (
                    <div className="text-center text-muted d-flex flex-column justify-content-center h-100">
                      <i className="fas fa-users fs-2 mb-2 opacity-25"></i>
                      <small className="fs-11">{t("noEmployeesAssignedToday")}</small>
                    </div>
                  ) : (
                    <div className="row g-3">
                      {todayEmployees.map((employee, index) => {
                        const initials = employee.Name
                          ? employee.Name.split(" ")
                            .map(n => n[0])
                            .join("")
                            .substring(0, 2)
                            .toUpperCase()
                          : "NA";

                        const colorScheme = avatarColors[index % avatarColors.length];

                        return (
                          <div className="col-12" key={employee.UserId || index}>
                            <div className="d-flex align-items-center gap-2">
                              <div className={`avatar avatar-xl status-${employee.status} position-relative`}>
                                <div className={`avatar-name rounded-circle ${colorScheme.bg} ${colorScheme.text} fw-bold d-flex align-items-center justify-content-center`}>
                                  {initials}
                                </div>
                              </div>
                              <div className="flex-grow-1 min-w-0">
                                <p className="mb-0 text-muted fw-medium font-size-13">{employee.Name || t("Unknown")}</p>
                                <div className="d-flex align-items-center gap-1 flex-wrap">
                                  <span className="text-muted d-block fw-normal font-size-12">
                                    {employee.status === "online" ? t("onSite") : t("scheduled")}
                                  </span>
                                  {employee.tasksCount > 1 && (
                                    <span className="text-muted fs-11">
                                      • {employee.tasksCount} {t("tasks")}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Overview;